import VariantSelects from './VariantSelects.js';

/**
 * Variant Radios
 */
export default class VariantRadios extends VariantSelects {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'VariantRadios',
    ...VariantSelects.config.options,
    options: {
      section: {
        type: String,
        default: () => '',
      },
    },
  };

  /**
   * Get gallery ID
   * @returns {string}
   */
  get galleryId() {
    return `gallery-${this.$options.section}`;
  }

  /**
   * mounted
   */
  mounted() {
    super.mounted();
    this.originalFirstImage = null;
    this.setupHoverEvents();
  }

  /**
   * onWindowGalleryupdate
   */
  onWindowGalleryupdate() {
    const firstGalleryImage = document.querySelector(`#${this.galleryId} img`);
    if (firstGalleryImage) {
      this.originalFirstImage = {
        src: firstGalleryImage.src,
        srcset: firstGalleryImage.srcset || '',
      };
    }

    setTimeout(() => {
      this.setupHoverEvents();
      this.$root.$update();
    }, 10);
  }

  /**
   * Setup hover events for variant option labels
   * @returns {void}
   */
  setupHoverEvents() {
    console.log('setupHoverEvents');
    const labels = this.$el.querySelectorAll('label');
    labels.forEach((label) => {
      label.addEventListener('mouseenter', (event) => this.onVariantHover(event));
      label.addEventListener('mouseleave', () => this.onVariantHoverEnd());
    });
  }

  /**
   * Handle variant option hover
   * @param {Event} event Mouse event
   * @returns {void}
   */
  onVariantHover(event) {
    const input = this.$el.querySelector(`#${event.target.getAttribute('for')}`);

    if (!input) {
      return;
    }

    const variantData = this.getVariantData();
    const currentOptions = [...this.options];

    // Update the option value for the hovered input
    const fieldsets = Array.from(this.$el.querySelectorAll('fieldset'));
    const hoveredFieldset = input.closest('fieldset');
    const fieldsetIndex = fieldsets.indexOf(hoveredFieldset);

    if (fieldsetIndex !== -1) {
      currentOptions[fieldsetIndex] = input.value;
    }

    // Find variant that matches the hovered options
    const hoveredVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return currentOptions[index] === option;
        })
        .includes(false);
    });

    if (hoveredVariant && hoveredVariant.featured_image) {
      console.log('hoveredVariant', hoveredVariant.featured_image);
      this.showVariantImage(hoveredVariant.featured_image);
    }
  }

  /**
   * Handle variant option hover end
   * @returns {void}
   */
  onVariantHoverEnd() {
    this.restoreOriginalImage();
    this.$root.$update();
  }

  /**
   * Show variant featured image in gallery
   * @param {string} imageSrc Source URL of the variant image
   * @returns {void}
   */
  showVariantImage(imageSrc) {
    const firstGalleryImage = document.querySelector(`#${this.galleryId} img`);
    if (!firstGalleryImage) {
      return;
    }

    if (!this.originalFirstImage) {
      this.originalFirstImage = {
        src: firstGalleryImage.src,
        srcset: firstGalleryImage.srcset || '',
      };
    }

    // Update the first image with variant image
    firstGalleryImage.src = imageSrc;
    firstGalleryImage.srcset = '';
    setTimeout(() => {
      this.$root.$update();
    }, 0);
  }

  /**
   * Restore original first gallery image
   * @returns {void}
   */
  restoreOriginalImage() {
    if (!this.originalFirstImage) {
      return;
    }

    const firstGalleryImage = document.querySelector(`#${this.galleryId} img`);
    if (firstGalleryImage) {
      firstGalleryImage.src = this.originalFirstImage.src;
      firstGalleryImage.srcset = this.originalFirstImage.srcset;
    }
    this.$root.$update();
  }

  /**
   * Override update options
   * @returns {void}
   */
  updateOptions() {
    const fieldsets = Array.from(this.$el.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
